const initialState = {
  auth: {},
  toast: { toast: false, severity: "info", content: "" },
  tariff: {},
  user: null,
  sidebar: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_MODE":
      return {
        ...state,
        mode: action.payload,
      };
    case "SET_COLOR":
      return {
        ...state,
        color: action.payload,
      };
    case "SET_AUTH":
      return {
        ...state,
        auth: action.payload,
      };
    case "SET_TOAST":
      return {
        ...state,
        toast: action.payload,
      };
    case "SET_TARIFF":
      return {
        ...state,
        tariff: action.payload,
      };
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_SIDEBAR_OPEN":
      return {
        ...state,
        sidebar: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
